import { ApiResponse } from '@/shared/types';
import { GetSpaceMeResponseType } from '@/shared/types/space/get-space-me-type';
import { axiosClient } from '@/shared/apis/config';
import { useQuery } from '@tanstack/react-query';
import { CustomQueryOptions } from '@/shared/types/global/react-query/query';
import { useSpaceStore } from '@/shared/store/space-store';
import { useTokenStore } from '@/shared/store/token-store';
import { createAuthQueryScope } from '@/shared/apis/auth-query-scope';

export type getSpaceMeResponse = ApiResponse<GetSpaceMeResponseType>;

export const getSpaceMeApi = async () => {
  try {
    const response =
      await axiosClient.get<getSpaceMeResponse>('/v1.0/space/me');
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUseGetSpaceMeApi = 'getSpaceMe' as const;

export const useGetSpaceMeApi = (
  options?: CustomQueryOptions<getSpaceMeResponse>,
) => {
  const { queryKey, enabled, ...rest } = options ?? {};
  const { accessToken, switchAccessToken } = useTokenStore();
  const { setSpaceId } = useSpaceStore();
  const authQueryScope = createAuthQueryScope(accessToken, switchAccessToken);

  return useQuery({
    queryKey: [QueryKeyUseGetSpaceMeApi, authQueryScope, ...(queryKey ?? [])],
    enabled: !!accessToken && (enabled ?? true),
    queryFn: async () => {
      const data = await getSpaceMeApi();
      if (data?.data?.id) {
        setSpaceId(String(data.data.id));
      }

      return data;
    },
    retry: false,
    ...rest,
  });
};
